import { functions, auth } from "./firebase";
import { httpsCallable } from "firebase/functions";

export async function checkAdminClaim() {
  const user = auth.currentUser;
  if (!user) return false;
  try {
    const tokenResult = await user.getIdTokenResult(true);
    return !!tokenResult.claims?.admin;
  } catch {
    return false;
  }
}

export async function adminGetMetrics() {
  try {
    const fn = httpsCallable(functions, "adminGetMetrics");
    const res = await fn({});
    if (res.data?.ok) {
      return { ok: true, metrics: res.data.metrics };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied" || err?.message?.includes("Admin")) {
      return { error: "unauthorized" };
    }
    return { error: err?.message || "fail" };
  }
}

export async function adminGrant({ uid, status }) {
  try {
    const fn = httpsCallable(functions, "adminGrant");
    const res = await fn({ uid, status });
    if (res.data?.ok) {
      return { ok: true, ...res.data };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied" || err?.message?.includes("Admin")) {
      return { error: "unauthorized" };
    }
    return { error: err?.message || "fail" };
  }
}

export async function adminSetFlag({ flag, value }) {
  try {
    const fn = httpsCallable(functions, "setFlag");
    const res = await fn({ flag: flag || "aiEnabled", value, aiEnabled: value });
    if (res.data?.ok) {
      return { ok: true, aiEnabled: res.data.aiEnabled };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied" || err?.message?.includes("Admin")) {
      return { error: "unauthorized" };
    }
    return { error: err?.message || "fail" };
  }
}

export async function adminGetGrants() {
  try {
    const fn = httpsCallable(functions, "adminGetGrants");
    const res = await fn({});
    if (res.data?.ok) {
      return { ok: true, grants: res.data.grants || [] };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied" || err?.message?.includes("Admin")) {
      return { error: "unauthorized" };
    }
    return { error: err?.message || "fail" };
  }
}
